import {getQueryStringVariable, getFullWidth, getFullHeight} from "./utilities";

/**
 * Main Hamburger Nav animations and open/close stuff, also scroll progress circle
 *
 * TODO: set circles to vw styles after animation completes?
 * TODO: close on scroll/resize? or reposition content scrollintoview on close?
 * TODO: need reisze listener to toggle titles visibility on mobile vs desktop
 *
 */
let Nav = function (params) {
  // console.log('Nav initalizing ' + params);

  let self = this;
  let markers = false;
  if (getQueryStringVariable('markers') === 'true') {
    markers = true;
  }

  // Progress circle around the button
  let parentWrapper = document.getElementById('bp3-wrapper');
  let navButton = parentWrapper.querySelector('#nav-button-wrapper');
  let scrollProgress = navButton.querySelector('#progress-path');
  gsap.set(scrollProgress, {drawSVG:0});
  gsap.fromTo(scrollProgress, 1.25, {drawSVG:"0"}, {
    scrollTrigger: {
      id: 'nav',
      trigger: '#content',
      start: '0% 0%',
      end: '100% 100%',
      markers: markers,
      scrub: true
    },
    drawSVG:'0 100%',
    ease: Linear.easeNone
  });

  // open and close clicks
  let navElement = parentWrapper.querySelector('#bp3-main-nav');
  let navBlackout = parentWrapper.querySelector('#nav-blackout');
  let circle1 = parentWrapper.querySelector('#red-circle1');
  let circle2 = parentWrapper.querySelector('#red-circle2');
  let circle1Tween, circle2Tween, blackoutTween, titleTween;
  let isOpen = false;
  navButton.addEventListener('click', navClicked);

  function navClicked(e) {
    if (isOpen) {
      closeNav();
    } else {
      openNav();
    }
  }

  function killTweens() {
    if (circle1Tween !== undefined) {
      circle1Tween.kill();
    }
    if (circle2Tween !== undefined) {
      circle2Tween.kill();
    }
    if (blackoutTween !== undefined) {
      blackoutTween.kill();
    }
    if (titleTween !== undefined) {
      titleTween.kill();
    }
  }

  let titles = parentWrapper.querySelector('#title-wrapper');
  // let titleElements = titles.querySelectorAll('h2');
  function openNav() {
    // toggle css classes
    if (navButton.classList.contains('is-active') === false) {
      navButton.classList.add('is-active');
    }
    // set open flag
    isOpen = true;
    killTweens();

    // calculate circle diameter
    let targetDiameter = getFullWidth();
    if (getFullHeight() > targetDiameter) {
      targetDiameter = getFullHeight() * 1.3;
    }

    // animate the circle
    gsap.set(navBlackout, {display: 'block'});
    gsap.set(navElement, {display: 'block'});
    blackoutTween = gsap.to(navBlackout, {opacity: 0.75, duration: 0.5});
    let titleOpacity = 1;
    if (getFullWidth() < 768) {
      titleOpacity = 0;
    }
    titleTween = gsap.to(titles, {opacity: titleOpacity, duration: 0.2});
    circle1Tween = gsap.to(circle1, {width: Math.round(targetDiameter * 1.5), height: Math.round(targetDiameter * 1.5), duration: 2, ease: 'elastic.out(0.9, 0.45)'});
    circle2Tween = gsap.to(circle2, {width: Math.round(targetDiameter * 1.3), height: Math.round(targetDiameter * 1.3), duration: 2, ease: 'elastic.out(0.9, 0.5)', delay: 0.1});
    gsap.fromTo(navElement, {opacity: 0}, {opacity: 1, delay: 0.5});

    // stop the body scroll? *Doesn't work on iOS
    let body = document.body;
    // body.style.position = "fixed";
    body.style.height = "100%";
    body.style.overflow = "hidden";

    // selected title gradient transition to dark
    let selectedTitle = parentWrapper.querySelector('#section' + window.bp3Application.currentSectionIndex.toString() + '-title');
    if (selectedTitle !== null) {
      // let titleH2 = selectedTitle.querySelector('h2');
      let titleH2 = parentWrapper.querySelectorAll('h2');
      // let titleH4 = selectedTitle.querySelector('h4');
      if (titleH2 !== null) {
        // gsap.killTweensOf(titleH2);
        titleH2.forEach(function(element) {
          gsap.killTweensOf(element, {backgroundImage:true});
        })
        // gsap.killTweensOf(titleH2, {backgroundImage:true});
        gsap.to(titleH2, {backgroundImage: '-webkit-linear-gradient(45deg, #525b5c, #000000)', duration: 0.5});
      }
    }

    setActiveLink();
    setDepths();
  }

  function closeNav() {
    navButton.classList.remove('is-active');
    isOpen = false;
    killTweens();
    blackoutTween = gsap.to(navBlackout, {opacity: 0, duration: 0.3, onComplete: function() {
        gsap.set(navBlackout, {display: 'none'});
        gsap.set(navElement, {display: 'none'});
      }});
    circle1Tween = gsap.to(circle1, {width: 0, height: 0, duration: 0.3, ease: 'power2.out'});
    circle2Tween = gsap.to(circle2, {width: 0, height: 0, duration: 0.3, ease: 'power2.out'});
    titleTween = gsap.to(titles, {opacity: 1, duration: 0.3});
    gsap.to(navElement, {opacity: 0, duration: 0.1});

    // // selected title gradient
    let selectedTitle = parentWrapper.querySelector('#section' + window.bp3Application.currentSectionIndex.toString() + '-title');
    if (selectedTitle !== null) {
      // let titleH2 = selectedTitle.querySelector('h2');
      let titleH2 = parentWrapper.querySelectorAll('h2');
      // let titleH4 = selectedTitle.querySelector('h4');
      if (titleH2 !== null) {
        // gsap.killTweensOf(titleH2);
        gsap.to(titleH2, {backgroundImage: '-webkit-linear-gradient(45deg, #525b5c, #FFFFFF)', duration: 0.5});
      }
      // if (titleH4 !== null) {
      //   // gsap.killTweensOf(titleH2);
      //   gsap.to(titleH4, {opacity: 1, duration: 0.2});
      // }
    }

    gsap.set(navElement, {opacity: 0});
    let body = document.body;
    // body.style.position = "relative";
    body.style.height = "auto";
    body.style.overflowY = "scroll";
    body.style.overflowX = "hidden";
  }

  // remove active class then add to current
  function setActiveLink () {
    // close on button link clicks
    let links = navElement.querySelectorAll('.link');
    for (const link of links) {
      if (link.classList.contains('is-active')) {
        link.classList.remove('is-active');
      }
    }

    if (window.bp3Application.currentSectionIndex === 0) {
      navElement.querySelector('#intro-link').classList.add('is-active');
    } else {
      navElement.querySelector('#section' + window.bp3Application.currentSectionIndex.toString() + '-link').classList.add('is-active');
    }
  }

  function setDepths() {
    // console.log('Nav.setDepths ' + window.bp3Application.currentSectionIndex);
    if (window.bp3Application.currentSectionIndex === 0) {
      parentWrapper.querySelector('#titles').style.zIndex = '0';
    } else {
      parentWrapper.querySelector('#titles').style.zIndex = '5';
    }
  }

  function linkClicked(event) {
    // console.log('clicked ', event);
    let index = event.target.getAttribute('data-section-id');
    let position = window.bp3Application.firstContentPositions[index];
    window.scrollTo({top: position});
    // console.log('scroll to ' + position);
    closeNav();
  }

  // close nav on button link clicks
  let links = navElement.querySelectorAll('.link');
  for (const link of links) {
    link.addEventListener('click', linkClicked);
  }
};

export default Nav;

